import { render } from "./ImportData.vue?vue&type=template&id=2168fdea&scoped=true&ts=true"
import script from "./ImportData.vue?vue&type=script&lang=ts"
export * from "./ImportData.vue?vue&type=script&lang=ts"

import "./ImportData.vue?vue&type=style&index=0&id=2168fdea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2168fdea"]])

export default __exports__